import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AVISO_INSTRUTOR_SEM_AREA, PARAM_AVISO_AREA } from '@/lib/navegacao';

/**
 * Aviso para perfil que ainda NÃO tem área própria.
 *
 * Existe porque a alternativa era pior: mandar o instrutor para /dashboard, que é
 * a área de aluno. Preferimos a home pública com explicação a um destino errado
 * em silêncio. Some sozinho quando a área do instrutor existir — basta parar de
 * emitir o parâmetro em homeDoPerfil.
 */
const MENSAGENS: Record<string, { titulo: string; texto: string }> = {
  [AVISO_INSTRUTOR_SEM_AREA]: {
    titulo: 'Sua área de instrutor ainda está em construção',
    texto:
      'Seu login funcionou normalmente. O painel do instrutor está sendo refeito e ainda não tem tela própria — por isso você está aqui, e não numa área que não é sua.',
  },
};

export default function AvisoPerfilSemArea() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [fechado, setFechado] = useState(false);

  const chave = searchParams.get(PARAM_AVISO_AREA);
  const mensagem = chave ? MENSAGENS[chave] : undefined;

  if (!mensagem || fechado) return null;

  const dispensar = () => {
    setFechado(true);
    const proximos = new URLSearchParams(searchParams);
    proximos.delete(PARAM_AVISO_AREA);
    setSearchParams(proximos, { replace: true });
  };

  return (
    <div
      role="status"
      className="relative z-50 bg-[#D4AF37]/[0.08] border-b border-[#D4AF37]/25"
    >
      <div className="max-w-5xl mx-auto flex items-start gap-3 px-4 py-3 lg:px-8">
        <span className="w-5 h-5 flex items-center justify-center text-[#D4AF37] shrink-0 mt-0.5">
          <i className="ri-information-line text-base" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-[#D4AF37]">{mensagem.titulo}</p>
          <p className="text-xs text-gray-400 mt-1 leading-relaxed">{mensagem.texto}</p>
        </div>
        <button
          onClick={dispensar}
          aria-label="Fechar aviso"
          className="w-6 h-6 flex items-center justify-center rounded-md text-gray-500 hover:text-white hover:bg-white/10 transition-all cursor-pointer shrink-0"
        >
          <i className="ri-close-line text-sm" />
        </button>
      </div>
    </div>
  );
}
